export const calculateProfitBeforeTax = (ec, p, q) => parseFloat(q) * (parseFloat(p) - parseFloat(ec));

export const calculateProfitAfterTax = (profitBeforeTax, section102, diffInYears, tax) => {
  let profitAfterTax;
  if (section102 === 'y' && diffInYears > 2) {
    profitAfterTax = profitBeforeTax * 0.75;
  } else {
    const effectiveTax = 1 - parseFloat(tax) / 100.0;
    profitAfterTax = profitBeforeTax * effectiveTax;
  }
  return profitAfterTax;
};
